import { Text } from '@mantine/core';
import type { ReactNode } from 'react';

/**
 * What a stock form already knows before it opens.
 *
 * Every one of these forms used to start blank wherever it was opened from, so correcting the
 * figure on the row in front of you meant finding that item again in a list of everything the
 * business buys, and that shelf again in a list of every shelf. The subject you are looking at is
 * the subject the action is about; these props are how the form is told so.
 */
export interface StockActionProps {
  /** The item this is already about. */
  inventoryItemId?: string;
  /** The shelf this is already about. */
  storageLocationId?: string;
  /** Wording for the trigger where the surrounding text already says what it acts on. */
  label?: string;
  /** Sits inside a table row rather than a section header. */
  compact?: boolean;
}

/**
 * A field the form was told rather than asked.
 *
 * Shown, not hidden — the manager has to be able to see that the waste is going against Flor de
 * Caña in the walk-in and not something else — and not editable, because a picker holding every
 * item in the business, opened with the right one already in it, is one stray click from logging
 * the wrong bottle.
 */
export function Known({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div>
      <Text size="xs" c="dimmed">
        {label}
      </Text>
      <Text size="sm" fw={500}>
        {value}
      </Text>
    </div>
  );
}
